import type { VisitType } from './api/types.ts';

/**
 * How a welfare visit's type is SHOWN. The stored value is unchanged (Arthur, 16 October): 'Initial Site
 * Visit' is a WELFARE visit type (it counts towards the four a year and meets the initial welfare visit), and
 * its name invited recording a property site visit there, which it does nothing for. So it is shown as
 * "Initial welfare visit" everywhere, with no migration and no row changed.
 */
const SHOWN: Partial<Record<VisitType, string>> = { 'Initial Site Visit': 'Initial welfare visit' };

export function visitTypeLabel(stored: string | null): string | null {
  return stored === null ? null : (SHOWN[stored as VisitType] ?? stored);
}
